if($('#ideafinder-filter').length) {
    var ideafinderData = {
        init: false,
        itemsPerLoad: 4,
        itemsPerRow: 1,
        itemsVisible: 0,
        itemsMax: 0,
        filter: [
            'form',
            'additional',
            'market',
            'manufacturing',
            'volume'
        ]
    }

    function ideafinderTemplate(name) {
        return $('#ideafinder-templates > [data-template="' + name + '"]').clone()
    }

    function ideafinderResize() {
        if($(window).width() < 576) {
            ideafinderData.itemsPerLoad = 4
            ideafinderData.itemsPerRow = 1
        } else if($(window).width() < 992) {
            ideafinderData.itemsPerLoad = 4
            ideafinderData.itemsPerRow = 2
        } else if($(window).width() < 1200) {
            ideafinderData.itemsPerLoad = 6
            ideafinderData.itemsPerRow = 3
        } else if($(window).width() < 1600) {
            ideafinderData.itemsPerLoad = 8
            ideafinderData.itemsPerRow = 4
        } else {
            ideafinderData.itemsPerLoad = 10
            ideafinderData.itemsPerRow = 5
        }

        if(ideafinderData.init)
            ideafinderRedraw()
    }

    function ideafinderRedraw() {
        ideafinderData.itemsVisible = 0

        var items = ideafinderTemplate('allItems')

        $('#ideafinder-grid').html(items.html())

        $.each(ideafinderData.filter, function() {
            var filter = this

            if($('#ideafinder-filter select[data-filter="' + filter + '"]').val() != '')
                $('#ideafinder-grid .ideafinder-item:not(.filter-' + $('#ideafinder-filter select[data-filter="' + filter + '"]').val() + ')').remove()
        })

        ideafinderData.itemsMax = $('#ideafinder-grid .ideafinder-item').length
        $('#ideafinder-counter').fadeOut(300, function() {
            $(this).text(ideafinderData.itemsMax).fadeIn(300)
        })

        if(ideafinderData.itemsMax > 0) {
            $('#ideafinder-no-result').hide()
            $('#ideafinder-grid').fadeIn(600)
        } else {
            $('#ideafinder-grid').hide()
            $('#ideafinder-no-result').fadeIn(600)
        }

        if(ideafinderData.itemsMax > ideafinderData.itemsVisible)
            $('#ideafinder-load-more').fadeIn(600)
        else
            $('#ideafinder-load-more').hide()

        ideafinderShowNext()
    }

    function ideafinderShowNext() {
        var itemsToLoad = ideafinderData.itemsPerLoad
        if(ideafinderData.itemsVisible == 0)
            itemsToLoad = ideafinderData.itemsPerLoad - 1

        if($('#ideafinder-grid .ideafinder-info').length) {
            $('#ideafinder-grid .ideafinder-item.ideafinder-active').removeClass('ideafinder-active')
            $('#ideafinder-grid .ideafinder-info').remove()
        }

        if($('#ideafinder-grid .ideafinder-contact-item').length) {
            var contactTilePosition = $('#ideafinder-grid .ideafinder-contact-item').offset().top
            $('#ideafinder-grid .ideafinder-contact-item').remove()
        }

        $('#ideafinder-grid .ideafinder-item:hidden').each(function(i) {
            if(i < itemsToLoad) {
                $(this).fadeIn(300)
                ideafinderData.itemsVisible++
            }
        })

        var contactTile = ideafinderTemplate('contactTile')
        $(contactTile.html()).insertAfter($('#ideafinder-grid > div:nth-child(' + ideafinderData.itemsVisible + ')'))

        if(ideafinderData.itemsMax > ideafinderData.itemsVisible)
            $('#ideafinder-load-more').fadeIn(600)
        else
            $('#ideafinder-load-more').hide()

        if(typeof contactTilePosition !== 'undefined' && contactTilePosition - $('header').outerHeight() > $(window).scrollTop())
            $('html, body').animate({
                scrollTop: contactTilePosition - $('header').outerHeight()
            }, 600)
    }

    function ideafinderCloseInfo(callback) {
        if($('#ideafinder-grid .ideafinder-item.ideafinder-active').length)
            $('#ideafinder-grid .ideafinder-item.ideafinder-active').removeClass('ideafinder-active')

        $('#ideafinder-grid .ideafinder-info').slideUp(600, function() {
            $('#ideafinder-grid .ideafinder-info').remove()

            if(typeof callback !== 'undefined')
                callback()
        })
    }

    function ideafinderShowInfo(item) {
        var item = $(item)
        var infoTile = ideafinderTemplate('infoTile')

        infoTile.find('.ideafinder-info-content').html(item.find('.ideafinder-info-content').html())
        infoTile.find('.ideafinder-info-images').html(item.find('.ideafinder-info-images').html())

        var insertPosition = item.index() + (ideafinderData.itemsPerRow - item.index() % ideafinderData.itemsPerRow)

        if($('#ideafinder-grid .ideafinder-info').length)
            ideafinderCloseInfo(function() {
                if(!$('#ideafinder-grid > div:nth-child(' + insertPosition + ')').length)
                    insertPosition = $('#ideafinder-grid > div').length
                $(infoTile.html()).insertAfter($('#ideafinder-grid > div:nth-child(' + insertPosition + ')'))
                if($('#ideafinder-grid .ideafinder-info .ideafinder-image-slider').length) {
                    if($('#ideafinder-grid .ideafinder-info .ideafinder-image-slider > img').length > 1)
                        $('#ideafinder-grid .ideafinder-info').find('.ideafinder-image-placeholder, .ideafinder-info-images').css('padding-bottom', '30px')

                    item.addClass('ideafinder-active')

                    if(item.offset().top - $('header').outerHeight() > $(window).scrollTop())
                        $('html, body').animate({
                            scrollTop: item.offset().top - $('header').outerHeight()
                        }, 600)

                    $('#ideafinder-grid .ideafinder-info').slideDown(600, function() {
                        $('#ideafinder-grid .ideafinder-info .ideafinder-image-placeholder').remove()
                        $(this).find('.ideafinder-image-slider').show().slick({
                            arrows: false,
                            dots: true,
                            infinite: false,
                            slidesToShow: 1,
                            autoplay: true,
                            autoplaySpeed: 3000
                        })
                    })
                } else {
                    item.addClass('ideafinder-active')

                    if(item.offset().top - $('header').outerHeight() > $(window).scrollTop())
                        $('html, body').animate({
                            scrollTop: item.offset().top - $('header').outerHeight()
                        }, 600)
                    $('#ideafinder-grid .ideafinder-info').slideDown(600)
                }
            })
        else {
            if(!$('#ideafinder-grid > div:nth-child(' + insertPosition + ')').length)
                insertPosition = $('#ideafinder-grid > div').length
            $(infoTile.html()).insertAfter($('#ideafinder-grid > div:nth-child(' + insertPosition + ')'))
            if($('#ideafinder-grid .ideafinder-info .ideafinder-image-slider').length) {
                if($('#ideafinder-grid .ideafinder-info .ideafinder-image-slider > img').length > 1)
                    $('#ideafinder-grid .ideafinder-info').find('.ideafinder-image-placeholder, .ideafinder-info-images').css('padding-bottom', '30px')

                item.addClass('ideafinder-active')

                if(item.offset().top - $('header').outerHeight() > $(window).scrollTop())
                    $('html, body').animate({
                        scrollTop: item.offset().top - $('header').outerHeight()
                    }, 600)

                $('#ideafinder-grid .ideafinder-info').slideDown(600, function() {
                    $('#ideafinder-grid .ideafinder-info .ideafinder-image-placeholder').remove()
                    $(this).find('.ideafinder-image-slider').show().slick({
                        arrows: false,
                        dots: true,
                        infinite: false,
                        slidesToShow: 1,
                        autoplay: true,
                        autoplaySpeed: 3000
                    })
                })
            } else {
                item.addClass('ideafinder-active')

                if(item.offset().top - $('header').outerHeight() > $(window).scrollTop())
                    $('html, body').animate({
                        scrollTop: item.offset().top - $('header').outerHeight()
                    }, 600)
                $('#ideafinder-grid .ideafinder-info').slideDown(600)
            }
        }
    }

    function ideafinderInit() {
        ideafinderData.itemsMax = $('#ideafinder-items > .ideafinder-item').length
        ideafinderRedraw()
        ideafinderData.init = true
    }

    $('#ideafinder-grid').on('click', '.ideafinder-item', function() {
        if(!$(this).hasClass('ideafinder-active'))
            ideafinderShowInfo(this)
        else
            ideafinderCloseInfo()
    })
    $('#ideafinder-grid').on('click', '.ideafinder-info-close', function() {
        ideafinderCloseInfo()
    })

    $('.ideafinder-reset').click(function(e) {
        e.preventDefault()
        $('#ideafinder-filter select').val('').selectpicker('refresh')
        ideafinderRedraw()
    })

    $('#ideafinder-load-more').click(function() {
        ideafinderShowNext()
    })

    $('#ideafinder-filter select').change(function() {
        ideafinderRedraw()
    })

    $(window).resize(function() {
        ideafinderResize()
    })
    ideafinderResize()

    ideafinderInit()
}


// WEBPACK FOOTER //
// ./js/parts/ideafinder.js